import { useCallback } from "react";
import { useRequestNurseMutation } from "@/rtkQuery/features/services/contactUs";
import type {
  ContactNurseRequest,
  ContactNurseResponse,
} from "@/rtkQuery/features/models/contactNurse.model";
import { toastService } from "@/utils/toastService"; 

export const useContactNurseService = () => {
  const [requestNurse, { data, error, isLoading, isSuccess, isError, status }] =
    useRequestNurseMutation();

  const submitNurseRequest = useCallback(
    async (
      payload: ContactNurseRequest
    ): Promise<ContactNurseResponse | undefined> => {
      try {
        const response = await requestNurse(payload).unwrap();
        toastService.success(
          response.Message || "Nurse request submitted successfully."
        );
        return response;
      } catch (err) {
        const errorMessage = "Error submitting nurse request.";
        toastService.error(errorMessage);
        return undefined;
      }
    },
    [requestNurse]
  );
  const contactANurseErrorMessage =
    (error as any)?.meta?.error ||
    (error as any)?.data?.message ||
    "Something went wrong while contacting a nurse";
 
  return {
    submitNurseRequest,
    contactANurseData: data,
    contactANurseError: error,
    contactANurseIsLoading: isLoading,
    contactANurseIsSuccess: isSuccess,
    contactANurseIsError: isError,
    contactANurseStatus: status,
    contactANurseErrorMessage,
  };
};
